<template>
  <div class="inactive-module">
    <img src="@/assets/img/inactive-module/Infringements.jpg" @click="openTips"/>
  </div>
</template>

<script>
export default {
  data(){
    return{
      option: null,
      mail: 'sirius@simplybrand.com'
    }
  },

  methods: {
    openTips: function(){
      this.mail = this.$store.state.partneremail != '' ? this.$store.state.partneremail : 'sirius@simplybrand.com'
      if(this.option){
        this.option.close()
      }
      this.option = this.$message({
        offset: 60,
        duration: 0,
        showClose: true,
        dangerouslyUseHTMLString: true,
        type: 'warning',
        message: '当前为示例页面，如需开通请联系客服<a style="color:#4169E1;" href="mailto:' + this.mail +'">邮箱</a>'
      })
    }
  }
}
</script>